/**
 * Type guard to check if a value is a valid number or a string that can be converted to a number.
 * @param value - The value to check.
 * @returns {boolean} - True if the value is a valid number or a string that can be converted to a number.
 */
export const isConvertibleToNumber = (
  value: number | string,
): value is number | string => {
  if (typeof value === "number") {
    return Number.isFinite(value);
  }
  if (typeof value === "string" && value.trim() !== "") {
    return Number.isFinite(Number(value));
  }
  return false;
};
